<template>
  <div class="error-page d-flex flex-column align-items-center justify-content-center">
    <div>ERROR</div>
    <b-button variant="danger" pill @click="retry">
      Retry
    </b-button>
  </div>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {};
  },
  methods: {
    retry() {
      this.$auth.logout({ returnTo: window.location.origin });
    },
  },
};
</script>

<style lang="scss">
.error-page {
  width: 100%;
  height: 100%;

  >div {
    &:nth-child(1) {
      font-weight: 600;
      font-size: 128px;
    }
    &:nth-child(2) {
      font-weight: 500;
      font-size: 24px;
    }
  }

  * {
    text-align: center;
  }
}
</style>